import React from 'react';

import type { ISVGElement } from 'components/icons/types';

export const MemberIcon = (props: ISVGElement) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#38A5FF" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.84615C9.68397 1.84615 7.80645 3.63701 7.80645 5.84615C7.80645 8.05529 9.68397 9.84615 12 9.84615C14.316 9.84615 16.1935 8.05529 16.1935 5.84615C16.1935 3.63701 14.316 1.84615 12 1.84615ZM5.87097 5.84615C5.87097 2.61741 8.61503 0 12 0C15.385 0 18.129 2.61741 18.129 5.84615C18.129 9.0749 15.385 11.6923 12 11.6923C8.61503 11.6923 5.87097 9.0749 5.87097 5.84615Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83272 16C6.12805 16 3.93548 18.0914 3.93548 20.6712C3.93548 20.8067 3.96144 20.9023 3.98865 20.958C4.01162 21.005 4.03133 21.0183 4.04776 21.0269C4.79984 21.4172 6.90852 22.1538 12 22.1538C17.0915 22.1538 19.2002 21.4172 19.9522 21.0269C19.9687 21.0183 19.9884 21.005 20.0114 20.958C20.0386 20.9023 20.0645 20.8067 20.0645 20.6712C20.0645 18.0914 17.872 16 15.1673 16H8.83272ZM2 20.6712C2 17.0718 5.05911 14.1538 8.83272 14.1538H15.1673C18.9409 14.1538 22 17.0718 22 20.6712C22 21.332 21.7492 22.1959 20.8774 22.6485C19.7224 23.2479 17.2448 24 12 24C6.75518 24 4.27757 23.2479 3.12265 22.6485C2.25079 22.1959 2 21.332 2 20.6712Z" />
  </svg>
);
